<template>
  <v-col cols="12" sm="6" lg="3">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="text-h6 font-weight-black"> Quantidade </v-card-text>

      <v-row>
        <v-col>
          <v-card-text class="text-h4 font-weight-black">
            {{ qtd ?? 0 }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "QuantidadeProfessoresCard",
  props: {
    franquiaId: {
      type: Number,
    },
  },
  watch: {
    franquiaId(value) {
      this.getQtd(value);
    },
  },
  mounted() {
    this.getQtd(this.franquiaId);
  },
  data() {
    return {
      loading: true,
      qtd: 0,
    };
  },
  methods: {
    async getQtd(franquiaId) {
      if (!franquiaId) return;
      this.loading = true;
      this.qtd = await this.$services.professoresService.qtd(franquiaId);
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
